module.exports = __webpack_public_path__ + "img/ca.69c606f8.png";